import { INDIVIDUAL } from './_http';
// import { queryString } from '../../helpers';
const getAppropriateCustomer = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/GetRoboAppropriateCustomer`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getDistributionHistory = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/GetDistributionHistory`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getPolicyRoboAdvisorInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/GetPolicyRoboAdvisorInfo?policyNo=${form.policyNo}`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getLastRecommendedDistribution = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/GetLastRecommendedDistribution`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const completeDistribution = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/CompleteDistribution`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const profiencyQuestions = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/ProfiencyQuestions`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const saveProfiencyAnswer = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/SaveProfiencyAnswer`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const rgpQuestions = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/RgpQuestions`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const saveRgpAnswer = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/SaveRgpAnswer`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const saveRoboAdvisorFundDemand = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/SaveFundDemandByRobo`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const saveRoboAdvisorDemand = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/SaveRoboAdvisorDemand`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
export {getAppropriateCustomer, getDistributionHistory,getPolicyRoboAdvisorInfo, getLastRecommendedDistribution, completeDistribution, profiencyQuestions, saveProfiencyAnswer, rgpQuestions,saveRgpAnswer,saveRoboAdvisorFundDemand,saveRoboAdvisorDemand }